import { defineMessages } from 'react-intl';

export default defineMessages({
  vehicleDialogTitle: {
    id: 'app.components.ApplicationOptionsDialog.vehicleDialogTitle',
    defaultMessage: 'Have a car?',
  },
  vehicleDialogContent: {
    id: 'app.components.ApplicationOptionsDialog.vehicleDialogContent',
    defaultMessage:
      'Do you have an available car for driving to and off this shift?',
  },
  vehicleDialogYes: {
    id: 'app.components.ApplicationOptionsDialog.vehicleDialogYes',
    defaultMessage: 'Yes, have a car',
  },
  vehicleDialogNo: {
    id: 'app.components.ApplicationOptionsDialog.vehicleDialogNo',
    defaultMessage: 'No',
  },
});
